<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="lostFounds" [lazy]="true" (onLazyLoad)="loadLazy($event, false)" dataKey="lostFoundId" selectionMode="single"
  [(selection)]="lostFound" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPaginator" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <div class="fs-5" [class.small-text]="reservationId">Lost And Found</div>
      </div>
      <div>
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem; margin-right:10px;" (click)="reloadPage()">Clear
            Filters</button>
          }

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem;" (click)="onOpenFormAdd()"
          [class.small-btn]="reservationId">New Lost Found +</button>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        @if (col.condition) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            @if (!reservationId) {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </th>
        }
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (!reservationId) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.shortTermRentalId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestLastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'itemName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'itemDesc', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestInquired', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestNotified', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'itemReturned', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'returnDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-lostFound>
    @if (reservationId && (reservationId == lostFound.reservationId)) {
      <tr [pSelectableRow]="lostFound">
        @if (!reservationId) {
          <td>{{lostFound.shortTermRentalId}} </td>
        }
        <td>{{lostFound.propertyCode}}</td>
        @if (!reservationId) {
          <td>{{lostFound.reservationId}} </td>
        }
        <td>{{lostFound.guestLastName}}</td>
        <td>{{lostFound.itemName}}</td>
        @if (!reservationId) {
          <td>{{lostFound.itemDesc}}</td>
        }
        <td>{{getStatusName(lostFound)}}</td>
        @if (!reservationId) {
          <td>{{lostFound.guestInquired}}</td>
        }
        @if (!reservationId) {
          <td>{{lostFound.guestNotified}}</td>
        }
        @if (!reservationId) {
          <td>{{lostFound.itemReturned}}</td>
        }
        <td>{{lostFound.returnDate}}</td>
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(lostFound)"></i>
          </a>
        </span>
      </td>
    </tr>
  }
  @if (!reservationId) {
    <tr [pSelectableRow]="lostFound">
      @if (!reservationId) {
        <td>{{lostFound.shortTermRentalId}} </td>
      }
      <td>{{lostFound.propertyCode}}</td>
      @if (!reservationId) {
        <td>{{lostFound.reservationId}} </td>
      }
      <td>{{lostFound.guestLastName}}</td>
      <td>{{lostFound.itemName}}</td>
      @if (!reservationId) {
        <td>{{lostFound.itemDesc}}</td>
      }
      <td>{{getStatusName(lostFound)}}</td>
      @if (!reservationId) {
        <td>{{lostFound.guestInquired}}</td>
      }
      @if (!reservationId) {
        <td>{{lostFound.guestNotified}}</td>
      }
      @if (!reservationId) {
        <td>{{lostFound.itemReturned}}</td>
      }
      @if (!reservationId) {
        <td>{{lostFound.returnDate}}</td>
      }
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(lostFound)"></i>
        </a>
      </span>
    </td>
  </tr>
}
</ng-template>
</p-table>